<template>
  <div class="casco-violation-letter">
    <LetterLayout
      :model="model"
      :signature-margin-line-count="0"
      @ready="$emit('ready')"
    >
      <template #from>
        <header class="casco-letterhead">
          <img :src="logo" alt="Casco — Rooted in what matters" />
        </header>
      </template>
      <template #to>
        <p>
          <template v-for="owner in model.ownersFormatted" :key="owner">
            {{ owner }}<br/>
          </template>
          {{ model.addressFormatted }}<br/>
          Casco, ME
        </p>
      </template>
      <template #date>
        <p>{{ model.dateFormatted }}</p>
      </template>
      <template #subject>
        <h1>Short-Term Rental (STR) Notice of Violation</h1>
      </template>

      <p>Dear {{ model.ownerFormatted }},</p>
      <p>
        We have reason to believe that your property, at <b>{{ model.addressFormatted }}</b>,
        is listed as a short-term rental<template v-if="model.listingUrl"> at {{ model.listingUrl }}</template>.
        However, this property is not currently licensed under our Short-Term Rental Ordinance.
      </p>
      <p>
        If this listing does not belong to you, then please disregard this message.
        Otherwise, please complete a license application either in person at our municipal offices at
        635 Meadow Road, Casco, ME 04015, or online at
        <a href="https://app.strenforcement.com/register/casco_me">https://app.strenforcement.com/register/casco_me</a>.
        Failure to do so may result in fines.
      </p>
      <p>
        The annual registration fee is $100.00. Payment may be made by mailing a check for $100.00
        payable to the Town of Casco.
      </p>
      <p>
        Please write “STR” followed by your rental property's address in the memo line of your check:
        <b>STR – {{ model.addressFormatted }}</b>.
      </p>
      <p>Please mail your payment to:</p>
      <p>
        Town of Casco<br/>
        635 Meadow Rd, Casco ME 04015
      </p>
      <p>If you have any questions regarding registration or payment, please contact:</p>
      <p>
        Devin Langadas<br/>
        Email: <a href="mailto:dlangadas@cascomaine.org">dlangadas@cascomaine.org</a><br/>
        Phone: 207-627-1346
      </p>
      <template #signature>
        <p>
          Sincerely,<br/>
          Devin Langadas, Deputy Code Enforcement Officer
        </p>
      </template>
      <template #footer>
        <footer class="casco-footer">
          <div>Phone (207) 627-4515</div>
          <div>
            635 Meadow Road<br/>
            Casco, Maine 04015<br/>
            www.cascomaine.org
          </div>
          <div>Fax (207) 803-1250</div>
        </footer>
      </template>
    </LetterLayout>
  </div>
</template>

<script>
import LetterLayout from "@/components/letters/LetterLayout.vue";
import {LetterContext} from "@/models/letterContext";
import logo from './casco-logo.png';

export default {
  components: {LetterLayout},
  props: {
    model: LetterContext
  },
  emits: ['ready'],
  data() {
    return { logo };
  }
}
</script>

<style scoped>
.casco-violation-letter {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 7.5in;
  min-height: 10in;
  margin: 0 auto;
  padding: 0 0.5in;
  color: #000;
  font-family: "Times New Roman", Times, serif;
  font-size: 12pt;
  line-height: 1.16;
  overflow-wrap: anywhere;
}

.casco-violation-letter :deep(.letter) {
  min-height: auto;
  margin: 0;
  padding: 0 !important;
  gap: 0 !important;
  font-size: inherit;
  line-height: inherit;
}

.casco-violation-letter :deep(.print-footer) {
  position: static;
  width: auto;
  height: auto;
  margin: auto 0 0 !important;
  padding-top: 0.3in;
}

.casco-letterhead {
  margin: 0 0 0.4in 0;
}

.casco-letterhead img {
  display: block;
  width: 2.28in;
  height: auto;
}

.casco-violation-letter h1,
.casco-violation-letter p {
  margin: 0 0 8pt;
  font-size: inherit;
  line-height: inherit;
}

.casco-violation-letter h1 {
  font-weight: bold;
}

.casco-violation-letter a {
  color: #467886;
  text-decoration: underline;
}

.casco-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8pt;
  font: italic 11pt/1.16 Arial, sans-serif;
  text-align: center;
}

.casco-violation-letter p,
.casco-footer {
  break-inside: avoid;
}

@media print {
  @page casco-violation-letter {
    size: letter;
    margin: 0.5in;
  }

  .casco-violation-letter {
    page: casco-violation-letter;
  }
}
</style>
